import React from 'react';

import MarkdownViewer from '../../newViews/Docs/MarkDownViewer';

const  routerWiki =
{
    showFirst:{
        id: 'Currencies_And_Fx_Exchange',
        links: [
            {
                path: 'Currencies_And_Fx_Exchange',
                title: 'Currencies_And_Fx_Exchange',
                view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/wiki/SETUP_Overview.md"/>
            }
        ],
        title: 'Getting Started with AVAP ID'
    },
    menus: [

        {
            id: 'over_view_id',
            path: 'GET STARTED_DisplayLanguage_index_nf1',
            title: 'AVAP ID',
            
            links:[
                {   path: 'GET STARTED_DisplayLanguage1',
                    title: 'Getting Started',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_AVAP_ID.md"/>
                 }
            ]
        },

        {
            id: 'over_view_cloud',
            path: 'GET STARTED_DisplayLanguage_index_nf2',
            title: 'AVAP Cloud',
            
            links:[
                {            path: 'GET STARTED_Cloud',
                    title: 'Getting Started',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_AVAP_Cloud.md"/> },
                {            
                    path: 'GET STARTED_Themes',
                    title: 'AVAP Organizations',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_AVAP_Organizations.md"/> },
                    {            
                        path: 'GET STARTED_Teams',
                        title: 'AVAP Developer Teams',
                        view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_AVAP_Developer_Teams.md"/> },
                        {            
                            path: 'GET STARTED_Ambients',
                            title: 'AVAP Ambients',
                            view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_AVAP_Ambients.md"/> },
                            {            
                                path: 'GET STARTED_Projects',
                                title: 'AVAP API Projects',
                                view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Default_API_Projects.md"/>,
                            },
                            {            
                                path: 'GET STARTED_Products',
                                title: 'AVAP API Products',
                                view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_API_Products.md"/> },
                              {            
                                    path: 'GET STARTED_My_1st_API',
                                    title: 'Creating my first API',
                                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Creating_My_First_API_Project_in_AVAP_Cloud.md"/> }
            ]
        },

        {
            id: 'over_view_cn',
            path: 'GET STARTED_DisplayLanguage_index_nf3',
            title: 'AVAP Collaborative Network',
            
            links:[
                {   path: 'GET STARTED_DisplayLanguage2',
                    title: 'Getting Started',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Getting_Started_with_AVAP_Collaborative_Network.md"/> }
            ]
        },

        {
            id: 'over_view_aefmvsc',
            path: 'GET STARTED_DisplayLanguage_index_nf4',
            title: 'AVAP API Extensions for MVSC',
            
            links:[
                {   path: 'GET STARTED_DisplayLanguage3',
                    title: 'Getting Started',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/GettingStarted_AVAP_Extensions_MVSC.md"/> }
            ]
        },

        {
            id: 'over_view_aefmvsc_cli',
            path: 'GET STARTED_DisplayLanguage_index_nf_cli',
            title: 'AVAP CLI',
            
            links:[
                {   
                    path: 'GET STARTED_Dev_Cli',
                    title: 'Getting Started with AVAP CLI',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_CLI_Guide.md"/>,
                },
                {   
                    path: 'GET STARTED_Dev_Token',
                    title: 'Create Your Developer Token',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Create_Your_Developer_Token.md"/> 
                }
            ]
        },
        {
            id: 'over_view12',
            path: 'GET STARTED_Downloads_index',
            title: 'Software Downloads',
            
            links:[{            path: 'GET STARTED_Downloads',
                title: 'How to Download AVAP Products?',
                view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/Software_Download.md"/> }]
        },
        {
            id: 'over_view13',
            path: 'GET STARTED_AVS_index',
            title: 'AVS (AVAP Virtual Server)',
            
            links:[
                {            
                    path: 'GET STARTED_AVS',
                    title: 'Getting Started',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avs_getting_started.md"/> },
                {            
                path: 'GET STARTED_AVS_ARC',
                title: 'Network Architecture Types',
                view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avs_infrastructure.md"/> }]
        },
        {
            id: 'over_view13a',
            path: 'GET STARTED_AVS_index_samples',
            title: 'Code Samples',
            
            links:[
                {            
                    path: 'GET STARTED_AVS_SAMPLE_1',
                    title: 'Hello World',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/hello_sample.md"/>,
                }
                    ,
                {            
                    path: 'GET STARTED_AVS_SAMPLE_2',
                    title: 'Authentication with user and password',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/login_sample.md"/>,
                },
                {            
                    path: 'GET STARTED_AVS_SAMPLE_3',
                    title: 'Select from a database',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/select_sample.md"/>,
                },
                {            
                    path: 'GET STARTED_AVS_SAMPLE_4',
                    title: 'Request data from url',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/http_get_request_sample.md"/>,
                
                },
                {            
                    path: 'GET STARTED_AVS_SAMPLE_5',
                    title: 'Loop sample',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/loop-sample.md "/>,
                }
                ]
        },
        

        {
            id: 'over_view14a',
            path: 'GET STARTED_AVS_index_publish',
            title: 'How to publish an API Product',
            
            links:[
                {            
                    path: 'PUBLISH_SAMPLE_1',
                    title: 'Get Started',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/publish_api.md"/>,
                }
                    
                ]
        },
        {
            id: 'over_view14b',
            path: 'GET STARTED_AVS_index_dockers',
            title: 'Official Docker Repository',
            
            links:[
                {            
                    path: 'avap_language_server_docker_doc',
                    title: 'AVAP Language Server',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avap-language-server-docs.md"/>,
                }, {            
                    path: 'avap_virtual_server_docker_doc',
                    title: 'AVAP Virtual Server',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avap-virtual-server-docs.md"/>,
                }, {            
                    path: 'avap_gateway_advanced_docker_doc',
                    title: 'AVAP Gateway Advanced',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avap-gateway-advanced-docs.md"/>,
                }
                    
                ]
        },
        {
            id: 'over_view14c',
            path: 'GET STARTED_AVS_index_kubernetes',
            title: 'Official Kubernete Deployment Repository',
            
            links:[
                {            
                    path: 'avap_language_server_deployment_doc',
                    title: 'AVAP Language Server',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avap-k8s-deployment-guide.md"/>
                }, {            
                    path: 'avap_virtual_server_deployment_doc',
                    title: 'AVAP Virtual Server',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avap-avs-k8s-deployment-guide.md"/>
                }, {            
                    path: 'avap_gateway_advanced_deployment_doc',
                    title: 'AVAP Gateway Advanced',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/avap-gateway-advanced-deployment-guide.md"/>
                }
            ]
        },        {
            id: 'over_view15c',
            path: 'GET STARTED_AVAP_Libraries',
            title: 'AVAP Developer Tool Kit',
            
            links:[
                {            
                    path: 'avap_library_creation_intro',
                    title: 'How to Create a Library',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
             /*   {            
                    path: 'avap_library_creation_required_components',
                    title: 'Required Components',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_process',
                    title: 'Process',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_basic_structure',
                    title: 'Basic Structure',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_variable_handling',
                    title: 'Variable Handling',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_variable_persistence',
                    title: 'Variable Persistence',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_Integration_with_AVAP',
                    title: 'Integration with AVAP',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_Library_Creation',
                    title: 'Library Creation',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_Best_Practices',
                    title: 'Best Practices',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                },
                {            
                    path: 'avap_library_creation_Implementation_Examples',
                    title: 'Implementation Examples',
                    view:<MarkdownViewer url="https://static.avapframework.com/static_images/docs/Developer_Portal_Docs/geting_started/AVAP_Library_document.md"/>
                }*/
            ]
        }       
    ],
    basePath: 'wiki/',
    titleNav: 'WIKI'
}

export default routerWiki;

